
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthFormSocialloginMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"backend"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isJwtAuth"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nextUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"giftcardToken"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referFriendId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"friendInvitationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upperFunnelSource"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpperFunnelSourceEnum"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upperFunnelJobToBeDone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpperFunnelJobToBeDoneEnum"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upperFunnelUrlSource"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"socialLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"backend"},"value":{"kind":"Variable","name":{"kind":"Name","value":"backend"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nextUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nextUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"giftcardToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"giftcardToken"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"referFriendId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referFriendId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"friendInvitationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"friendInvitationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isJwtAuth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isJwtAuth"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"upperFunnelSource"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upperFunnelSource"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"upperFunnelJobToBeDone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upperFunnelJobToBeDone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"upperFunnelUrlSource"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upperFunnelUrlSource"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"redirect"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isNewUser"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"jwtToken"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":822}};
    doc.loc.source = {"body":"mutation AuthFormSocialloginMutation(\n  $backend: String!\n  $token: String!\n  $isJwtAuth: Boolean\n  $nextUrl: String\n  $giftcardToken: String\n  $referFriendId: ID\n  $friendInvitationId: ID\n  $upperFunnelSource: UpperFunnelSourceEnum\n  $upperFunnelJobToBeDone: UpperFunnelJobToBeDoneEnum\n  $upperFunnelUrlSource: String\n) {\n  socialLogin(\n    input: {\n      backend: $backend\n      token: $token\n      nextUrl: $nextUrl\n      giftcardToken: $giftcardToken\n      referFriendId: $referFriendId\n      friendInvitationId: $friendInvitationId\n      isJwtAuth: $isJwtAuth\n      upperFunnelSource: $upperFunnelSource\n      upperFunnelJobToBeDone: $upperFunnelJobToBeDone\n      upperFunnelUrlSource: $upperFunnelUrlSource\n    }\n  ) {\n    success\n    redirect\n    isNewUser\n    jwtToken {\n      token\n      refreshToken\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["AuthFormSocialloginMutation"] = oneQuery(doc, "AuthFormSocialloginMutation");
        
